import { useEffect, useRef } from 'react';

const items = [
  {
    icon: 'ri-handbag-line',
    title: 'ブランド品',
    desc: 'バッグ・財布・アクセサリー・スカーフ・靴など',
    examples: 'LV・グッチ・エルメス・シャネル 他',
    image: 'https://public.readdy.ai/ai/img_res/c5c6af823f313bd875db787c71edf6fb.jpg',
  },
  {
    icon: 'ri-medal-2-line',
    title: '貴金属・宝石',
    desc: '金・プラチナ・銀製品・ダイヤ・ルビー・翡翠など',
    examples: '指輪・ネックレス・ブレスレット・ブローチ 他',
    image: 'https://readdy.ai/api/search-image?query=precious%20jewelry%20gold%20platinum%20diamonds%20rings%20necklaces%20gems%20elegant%20display%20dark%20background%20glittering%20high%20value%20items%20luxury%20collection&width=400&height=300&seq=item_jewelry_001&orientation=landscape',
  },
  {
    icon: 'ri-vip-crown-line',
    title: '骨董品・美術品',
    desc: '陶磁器・掛け軸・絵画・彫刻・茶道具など',
    examples: '和骨董・西洋骨董・民芸品・古書 他',
    image: 'https://readdy.ai/api/search-image?query=japanese%20antique%20ceramics%20pottery%20scroll%20paintings%20art%20objects%20traditional%20artifacts%20wooden%20shelves%20warm%20light%20elegant%20collection%20ancient%20valuable&width=400&height=300&seq=item_antique_001&orientation=landscape',
  },
  {
    icon: 'ri-scissors-cut-line',
    title: 'アイヌ刺繍',
    desc: 'アイヌ伝統の手刺繍・衣装・テキスタイルなど',
    examples: 'アットゥシ・チカップ刺繍・木綿衣装 他',
    image: 'https://readdy.ai/api/search-image?query=ainu%20traditional%20embroidery%20fabric%20handmade%20textile%20intricate%20geometric%20patterns%20hokkaido%20indigenous%20craft%20close%20up%20detailed%20stitching%20natural%20colors%20warm%20background&width=400&height=300&seq=item_ainu_embroidery_001&orientation=landscape',
  },
  {
    icon: 'ri-ancient-gate-line',
    title: 'アイヌ民芸品',
    desc: '木彫り・イクパスイ・マキリ・籠細工など',
    examples: '木彫り熊・儀式道具・装身具・工芸品 他',
    image: 'https://readdy.ai/api/search-image?query=ainu%20folk%20craft%20wooden%20carving%20traditional%20artifacts%20hokkaido%20indigenous%20bear%20sculpture%20ritual%20tools%20handcrafted%20wooden%20objects%20warm%20studio%20light%20natural%20materials&width=400&height=300&seq=item_ainu_craft_001&orientation=landscape',
  },
  {
    icon: 'ri-time-line',
    title: '時計',
    desc: '腕時計・懐中時計・置時計など',
    examples: 'ロレックス・オメガ・カルティエ・セイコー 他',
    image: 'https://readdy.ai/api/search-image?query=luxury%20watches%20collection%20rolex%20omega%20vintage%20timepieces%20elegant%20display%20dark%20wooden%20background%20precision%20craftsmanship%20sophisticated&width=400&height=300&seq=item_watch_001&orientation=landscape',
  },
  {
    icon: 'ri-tv-2-line',
    title: '家電・電化製品',
    desc: 'テレビ・カメラ・オーディオ・PC・スマートフォンなど',
    examples: 'Apple・Sony・Canon・Nikon 他',
    image: 'https://readdy.ai/api/search-image?query=electronics%20cameras%20audio%20equipment%20laptops%20smartphones%20clean%20modern%20arrangement%20white%20background%20technology%20devices%20high%20quality&width=400&height=300&seq=item_electronics_001&orientation=landscape',
  },
  {
    icon: 'ri-shirt-line',
    title: '衣類・服飾',
    desc: 'ブランド古着・着物・帯・コートなど',
    examples: 'ヴィンテージ・和装品・高級コート 他',
    image: 'https://readdy.ai/api/search-image?query=vintage%20clothing%20kimono%20japanese%20fashion%20elegant%20garments%20collection%20warm%20wooden%20background%20textiles%20soft%20lighting%20traditional&width=400&height=300&seq=item_clothes_001&orientation=landscape',
  },
  {
    icon: 'ri-music-line',
    title: '楽器',
    desc: 'ギター・バイオリン・管楽器・ピアノなど',
    examples: 'Gibson・Martin・Yamaha・Fender 他',
    image: 'https://readdy.ai/api/search-image?query=musical%20instruments%20guitars%20violin%20brass%20collection%20warm%20studio%20lighting%20wooden%20background%20classic%20vintage%20instruments%20elegant&width=400&height=300&seq=item_music_001&orientation=landscape',
  },
  {
    icon: 'ri-archive-line',
    title: 'その他なんでも',
    desc: 'コレクション品・おもちゃ・切手・コインなど',
    examples: 'フィギュア・鉄道模型・切手・古銭 他',
    image: 'https://readdy.ai/api/search-image?query=collectibles%20coins%20stamps%20figurines%20vintage%20toys%20mixed%20collection%20wooden%20table%20warm%20light%20nostalgic%20antique%20items%20eclectic&width=400&height=300&seq=item_other_001&orientation=landscape',
  },
];

export default function ItemsSection() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('.section-reveal').forEach((el, i) => {
              setTimeout(() => el.classList.add('visible'), i * 80);
            });
          }
        });
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="items" ref={sectionRef} className="py-24 md:py-32 bg-kura-green ainu-pattern">
      <div className="max-w-6xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16 section-reveal">
          <span
            className="text-kura-gold text-xs tracking-[0.4em] uppercase"
            style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
          >
            Items We Buy
          </span>
          <h2
            className="text-white text-3xl md:text-4xl font-bold mt-2 tracking-wide"
            style={{ fontFamily: 'Noto Serif JP, serif' }}
          >
            取扱品目
          </h2>
          <div className="ainu-border mt-4 max-w-xs mx-auto" />
          <p
            className="text-white/70 text-sm mt-4 max-w-lg mx-auto leading-relaxed tracking-wide"
            style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
          >
            「こんなものでも買取できるの？」と思ったらぜひご相談ください。
            <br />
            ジャンルを問わず、幅広く買取いたします。
          </p>
        </div>

        {/* Items Grid */}
        <div className="grid grid-cols-2 md:grid-cols-5 gap-4" data-product-shop>
          {items.map((item) => (
            <div
              key={item.title}
              className="section-reveal group bg-kura-green-mid/60 backdrop-blur-sm rounded-lg overflow-hidden border border-white/10 hover:border-kura-gold/50 transition-all duration-300 cursor-default"
            >
              {/* Image */}
              <div className="relative overflow-hidden" style={{ height: '140px' }}>
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-kura-green-mid/80 to-transparent" />
                <div className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center bg-kura-gold/20 rounded-full border border-kura-gold/40">
                  <i className={`${item.icon} text-kura-gold text-sm`} />
                </div>
              </div>

              {/* Content */}
              <div className="p-4">
                <h3
                  className="text-white font-semibold text-sm tracking-wide mb-1"
                  style={{ fontFamily: 'Noto Serif JP, serif' }}
                >
                  {item.title}
                </h3>
                <p
                  className="text-white/60 text-xs leading-relaxed mb-2"
                  style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
                >
                  {item.desc}
                </p>
                <p
                  className="text-kura-gold-light/70 text-xs"
                  style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
                >
                  {item.examples}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12 section-reveal">
          <p
            className="text-white/70 text-sm mb-4 tracking-wide"
            style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
          >
            掲載以外のものもお気軽にご相談ください。まずはお問い合わせを。
          </p>
          <button
            onClick={() => {
              const el = document.querySelector('#contact');
              if (el) el.scrollIntoView({ behavior: 'smooth' });
            }}
            className="border border-kura-gold text-kura-gold hover:bg-kura-gold hover:text-kura-dark px-8 py-3 rounded-md text-sm tracking-wide transition-all duration-300 cursor-pointer whitespace-nowrap"
            style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
          >
            無料査定はこちら
          </button>
        </div>
      </div>
    </section>
  );
}
